<template>

    <section class="sectionBackGround">
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center" style="margin-top: 10%;">
                    <div class="col-lg-7 text-center pt-lg">
                        <img src="http://anthromindxx.com/ant/smalllogo.svg" style="width: 50px;" class="img-fluid">

                        <template>
                            <div class="text-center zt">AnthroMindXX</div>
                            <div class="text-center zt">文献查询</div>

                            <div class="btn-wrapper" style="position: relative;">
                                <base-input class="mt-5" alternative placeholder="输入关键词搜索 或 使用 /latest 搜索最新文献"
                                    v-model="searchQuery" @keyup.enter="searchDocuments">
                                </base-input>
                                <!-- 手动添加搜索图标并监听点击事件 -->
                                <i class="fa fa-search search-icon" @click="searchDocuments"></i>
                            </div>

                        </template>
                    </div>
                </div>
            </div>
        </div>

    </section>

</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            searchQuery: '',  // 存储用户输入的关键词
        };
    },


    created() {
        // 页面加载时检查 token
        const token = this.getCookie('token');

        if (token) {
            this.verifyToken(token);
        } else {
            // 如果没有 token，跳转到登录页面
            this.$router.push('/login');  // 返回到登录页面
        }
    },
    methods: {
        // 获取cookie中的token
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        },
        async searchDocuments() {
            const token = this.getCookie('token');  // 获取token

            if (!token) {
               // alert('Token not found, please login');
                this.$router.push('/login');
                return;
            }

            if (this.searchQuery.trim() === '') {
                alert('请输入关键词');
                return;
            }

            try {
                // this.$router.push({
                //     name: 'DocQueryList',
                //     params: { searchQuery: this.searchQuery }  // 将关键词传递到列表页面
                // });

                // 使用 URL 编码格式发送数据
                // const params = new URLSearchParams();
                // params.append('token', token);  // 将 token 添加到请求体
                // params.append('keywords', this.searchQuery);  // 将关键词添加到请求体
                // params.append('page', 1);  // 搜索时从第一页开始
                // params.append('itemsPerPage', 10);  // 每页显示10个项目
                this.$router.push('/DocQueryList?searchQuery=' + this.searchQuery);

                // const response = await axios.post('https://anthromindxx.com/ca.php?action=search', params, {
                //     headers: {
                //         'Content-Type': 'application/x-www-form-urlencoded'
                //     }
                // });


                // if (response.data.success && response.data.posts.length > 0) {
                //     // 如果有搜索结果，保存结果并更新文档数
                //     this.$router.push({
                //         name: 'DocQueryList',
                //         params: {
                //             searchResults: response.data.posts,
                //             totalDocuments: response.data.totalDocuments,
                //             currentPage: 1, // 新搜索时重置页码为1
                //             itemsPerPage: 10 // 默认每页显示10个项目
                //         }
                //     });
                // } else {
                //     // 如果没有找到结果，清空结果并设置总文档数为0
                //     this.$router.push({
                //         name: 'DocQueryList',
                //         params: {
                //             searchResults: [],
                //             totalDocuments: 0,
                //             currentPage: 1,
                //             itemsPerPage: 10
                //         }
                //     });
                //     alert('没有找到相关结果，请尝试其他关键词');
                // }
            } catch (error) {
                console.error('Search request failed:', error);
            }
        },
        // 验证token
        async verifyToken(token) {
            try {
                // 使用 URL 编码格式发送数据
                const params = new URLSearchParams();
                params.append('keywords', this.searchQuery);
                params.append('token', token);
                params.append('page', this.currentPage); // 传递当前页码
                params.append('itemsPerPage', this.itemsPerPage); // 传递每页条目数
                params.append('token', token);

                const response = await axios.post('https://anthromindxx.com/ca.php?action=verifyToken', params, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });



                if (response.data.success) {
                    const { status, timeover } = response.data;
                    const parsedStatus = parseInt(status, 10);
                    const parsedTimeover = parseInt(timeover, 10);

                    if (parsedTimeover === 1 && (parsedStatus === 1 || parsedStatus === 3)) {
                        this.$router.push('/DocQuery');
                    } else {
                        this.$router.push('/AboutUs');
                    }
                } else {
                    console.error('Token verification failed:', response.data.message || 'Token validation failed');
                    this.$router.push('/login');
                }
            } catch (error) {
                console.error('Token verification request failed:', error);
                this.$router.push('/login');
            }
        },
    }
};
</script>
<style scoped>
.sectionBackGround {
    /* 使内容区域填充剩余空间 */
    min-height: calc(100vh - 48px);
    /* 确保内容区域至少与视口高度减去头部高度一样大 */
    background-image: url('https://anthromindxx.com/ant/BK.png');
    /* 设置背景图路径 */
    background-position: center center;
    /* 背景图片位置 */
    background-attachment: fixed;
    /* 背景图片相对于视口固定 */
    background-size: 100% 100%;
    /* 背景图片根据元素大小缩放 */
    overflow-y: auto;
    /* 在内容较多时显示滚动条 */
}

.zt {
    color: black;
    font-family: ‘Noto Sans S Chinese’;
    font-size: 40px;
    font-style: normal;
    font-weight: 800;
    line-height: 58px;
    letter-spacing: 1px;
}

/* 设置搜索图标的颜色和样式 */
.search-icon {
    color: #0ff5c8;
    cursor: pointer;
    position: absolute;
    /* 图标定位 */
    right: 20px;
    /* 距离输入框的右边位置 */
    top: 50%;
    /* 垂直居中 */
    transform: translateY(-50%);
    font-size: 18px;
    /* 图标大小 */
}

.wxch {
    width: 118px;
    position: relative;
    font-size: 28px;
    letter-spacing: 2px;
    line-height: 40px;
    display: inline-block;
    font-family: 'Noto Sans S Chinese';
    color: #333;
    margin: 0;
    line-height: normal;



}
</style>